import React, { useEffect } from 'react'
import { useState } from 'react'
import { SignupRequest, useGetCaptchaQuery, useSend_codeMutation, useSignupMutation, useSignupـcompleteMutation, useSite_createMutation, useSurvey_createMutation } from '../../Redux/Apis/authApi'
import { useGetFieldsQuery, useGetThemesQuery } from '../../Redux/Apis/utilApi'
import '../../assets/css/signup-style.css'
import img1 from '../../assets/images/steps.png'
import img2 from '../../assets/images/site-design.png'
import { Arrow } from "@egjs/flicking-plugins";
import "@egjs/flicking-plugins/dist/arrow.css";
import Flicking, { ViewportSlot } from "@egjs/react-flicking";
import { Perspective } from "@egjs/flicking-plugins";
import "@egjs/react-flicking/dist/flicking.css";
// Or, if you have to support IE9
import "@egjs/react-flicking/dist/flicking-inline.css";
import { fa_currency, fa_number } from '../../utils/Persian'
import { setCredentials } from '../../Redux/Slices/authSlice'
import { useDispatch } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../Redux/hooks/useAuth'

export default function Signup() {
    const [refresh, setRefresh ] = useState(1)
    const [type,setType] = useState(1)
    const [subType,setSubType] = useState(0)
    const [errorMsg, setErrorMsg] = useState<any>(false)
    const [checkme1,setCheckme1] = useState(true)
    const [checkme2,setCheckme2] = useState(true)
    const [extra,setExtra] = useState(false)
    const [lastStep,setLastStep] = useState(false)
    const [subDomain,setSubDomain] = useState('')
    const [passwordShown, setPasswordShown] = useState(false);
    const [rePasswordShown, setRePasswordShown] = useState(false);
    const togglePassword = () => {
        setPasswordShown(!passwordShown);
    }
    const toggleRePassword = () => {
        setRePasswordShown(!rePasswordShown);
    }
    
    const _plugins = [new Arrow(), new Perspective({ rotate: 0.1, scale: 0.2, perspective: 500 })];
    

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const auth = useAuth()

    useEffect(() => {
        if (type !== 4 && auth.user) navigate('/')
    })
    
    const [signup, {isLoading}] = useSignupMutation()
    const [signup_complete, {isLoading: isLastLoading}] = useSignupـcompleteMutation()
    const [site, {isLoading: isSiteLoading}] = useSite_createMutation()
    const [survey, {isLoading: isSurveyLoading}] = useSurvey_createMutation()
    const [send_code, {isLoading : isCodeLoading}] = useSend_codeMutation()
    
    const { data: themes , isLoading: themesLoading} = useGetThemesQuery({})
    const { data: fields , isLoading: fieldsLoading} = useGetFieldsQuery({})

    const { data } = useGetCaptchaQuery({refresh})
    const getCaptcha = () =>  {
        if (subType === 0) setRefresh((prev) => prev + 1)
    }

    const [formState, setFormState] = useState<SignupRequest>({
        mobile:'',
        name: '',
        family:'',
        password: '',
        rePassword:'',
        captcha: '',
        code: '',
        referral_code:'',

        site_name: '',
        domain: 'https://',
        field_id: null,
        theme_id: null,
        theme_name: '',
        is_new_domain: undefined,
        is_vip: false,
        is_consult: undefined,

        graphic: false,
        pages: 1,
        answers: {
            1 : '',
            2 : '',
            3 : '',
        }
    })

    const makeSubDomain = (domain: string) => {
        const new_domain = new URL(domain).hostname.replace(/^www\./, '');
        setSubDomain(
            `https://${new_domain.split('.')[0]}${new_domain.split('.')[1] !== undefined ? '-' + new_domain.split('.')[1] : ''}.linket.me`
        );
      }

    const handleChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement | HTMLSelectElement> ) =>
        {
            setFormState((prev) => ({ ...prev, [name]: value }));
            if (name === 'domain') makeSubDomain(value);
        }

    const handleAnswerChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> ) =>
        setFormState({
            ...formState, 
            answers: { 
              ...formState.answers, 
              [name]: value
            }
        });

    const checkInput = async (e : any) =>  {
        let error = ""
        const inputs = Array.from(e.target.querySelectorAll('input'))

        await Promise.all(inputs.map((input :any) => {
            switch (input.name) {
                case 'name':
                    if (input.value === "")
                        error = "نام نباید خالی باشد."
                    break;
                case 'family':
                    if (input.value === "")
                        error = "نام خانوادگی نباید خالی باشد."
                    break;
                case 'password':
                    if (input.value.length < 8 || !input.value.match(/((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/))
                        error = "رمز عبور می بایست حداقل ۸ کاراکتر و دارای عدد، حروف کوچک و بزرگ باشد"
                    break;
                case 'rePassword':
                    if (input.value !== formState.password)
                        error = 'رمز وارد شده با تکرار رمز تطابق ندارد'
                    break;
                case 'referral_code':
                    if (input.value) {
                        const refferal_code = parseInt(input.value)
                        if (isNaN(refferal_code))
                            error = 'کد معرف نامعتبر می باشد'
                    }
                    break;
                case 'captcha':
                    if (subType === 0 && input.value.length !== 4)
                        error = "کد کپتچا نامعتبر می باشد"
                    break;
                default:
                    break;
            }
            return input
        }))
        setErrorMsg( error )
        if (error)
            return true
    }

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            if(type === 1){
                if(subType === 0){
                    await send_code(formState).unwrap()
                    setSubType(10)
                }else{
                    if (await checkInput(e)) return
                    if (formState.referral_code === '') delete formState.referral_code
                    await signup(formState).unwrap()    
                    setType(2)
                    setSubType(1)
                }
            }else if(type === 2) {
                await site(formState).unwrap()
                setType(3)
            }else if(type === 3) {
                if(formState.is_vip){
                    await site(formState).unwrap()
                    await survey(formState).unwrap()
                } else
                    await site(formState).unwrap()

                setType(4)
            } else if(type === 4) {
                if (!formState.is_vip && !formState.theme_id) {
                    setErrorMsg("شما قالبی انتخاب نکرده ایید، لطفا از مرحله قبل ابتدا قالب خود را انتخاب نمایید.")
                    return
                }
                const user = await signup_complete(formState).unwrap()
                if(user.token){
                    dispatch(setCredentials(user))
                }
                if (!formState.is_vip) {
                    setLastStep(true)
                    setTimeout(() => {
                        navigate('/')
                    }, 25000);
                } else {
                    navigate('/')
                }
            }
            setErrorMsg(false) 
            
        } catch (err:any){
            // console.log(err);
            getCaptcha();
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }

    const calc_price = (pages:number, graphic:boolean | undefined) => {
        const base_price = 5000000;
        const g_base_price = 8000000;
        if (graphic === true) {
            return fa_currency(g_base_price + g_base_price * (pages - 1) * 0.3);
        } else {
            return fa_currency(base_price + base_price * (pages - 1) * 0.3);
        }
    }

    const errorTypes = (errorMsg:string) => {
        switch (errorMsg) {
            case 'نام کاربری قبلا ثبت نام شده، لطفا از بخش ورود وارد شوید.':
                return <p className='m-0'>{errorMsg} <Link to='/login' className='btn btn-outline-primary ms-2'>ورود به پنل</Link></p>
        
            case 'کد اعتبار سنجی نامعتبر می باشد.':
                return <p className='m-0'>{errorMsg} <button type='button' className='btn btn-outline-success ms-2' onClick={() => send_code(formState).unwrap()}>ارسال مجدد</button></p>
    
            default:
                return <p className='m-0'>{errorMsg}</p>
        }
    }

    return (
        <div className='container-lg' onSubmit={onSubmit}>
            <form id="signUpForm" className='row p-5' >
                <h3 className='text-center mb-5'>ثبت نام رایگان لینکِت</h3>
                
                <div className="form-header d-flex mb-4">
                    <span className={`stepIndicator ${type === 1 ? "active" : "finish"}`}>ثبت نام</span>
                    <span className={`stepIndicator ${type === 2 ? "active" : type > 2 ? "finish" : ""}`}>ایجاد سایت</span>
                    <span className={`stepIndicator ${type === 3 ? "active" : type > 3 ? "finish" : ""}`}>اطلاعات قالب</span>
                </div>
                
                {errorMsg && <div className="alert alert-danger" role="alert">
                    {
                        errorTypes(errorMsg)
                    }
                </div>}
                
                {type === 1 && 
                <div className='row align-items-center g-0'>
                    <div className='col-md-6 col-sm-12 mt-4 mb-4'>
                        <p className={`mb-4`}>لطفا جهت ثبت سایت موارد مشخص شده را با دقت تکمیل نمایید.</p>
                        <div className={`form-floating mb-3 ${subType === 0 ? "" : "d-none"}`}>
                            <input type="tel" disabled={subType === 10 || subType === 1} className="form-control" id="mobile" name='mobile' value={formState.mobile} onChange={handleChange} placeholder="شماره موبایل" pattern="[0-9]{11}" required/>
                            <label htmlFor="mobile">شماره موبایل</label>
                        </div>
                        <div className={`input-group mb-3 ${subType === 0 ? "" : "d-none"}`}>
                            <button className="btn btn-outline-secondary border border-secondary-subtle p-1" onClick={getCaptcha} type="button"><i className="zmdi zmdi-refresh-alt"></i></button>
                            <div role="button" onClick={getCaptcha} className="text-center border" dangerouslySetInnerHTML={{ __html: data?.data! }}></div>
                            <input type="text" disabled={subType === 10 || subType === 1} className='form-control' name="captcha" id='your_captcha' onChange={handleChange} placeholder="کد تصویر" maxLength={4} />
                        </div>

                        <div className={`border border-info border-5 rounded p-3 mb-4 text-center ${subType === 10 ? "d-block" : "d-none"}`}>
                            <div className='form-group '>
                                <label className='mb-1 text-secondary col-form-label-sm' htmlFor="user_code">کد پیامک شده به تلفن همراه شما</label>
                                <input type="text" className='form-control form-control-sm text-center' onChange={handleChange} name="code" id="user_code" placeholder="0-0-0-0-0-0"  maxLength={6}/>
                            </div>
                        </div>

                        <div className={`input-group mb-3 ${subType === 0 ? "d-none" : ""}`}>
                            <input type="text" id='name' name='name' className="form-control" value={formState.name} onChange={handleChange} placeholder="نام" aria-label="نام"/>
                            <input type="text" id='family' name='family' className="form-control" value={formState.family} onChange={handleChange} placeholder="نام خانوادگی" aria-label="نام خانوادگی"/>
                        </div>
                        <div className={`input-group mb-3 ${subType === 0 ? "d-none" : ""}`}>
                            <input type={passwordShown ? "text" : "password"}  id='password' name='password' className="form-control" value={formState.password} onChange={handleChange} placeholder="کلمه عبور" aria-label="کلمه عبور" aria-describedby="show-pass1"/>
                            <button className="btn btn-outline-light border border-secondary-subtle p-2" onClick={togglePassword} type="button" id="show-pass1"><i className="zmdi zmdi-eye text-secondary"></i></button>
                            <input type={rePasswordShown ? "text" : "password"}  id='rePassword' name='rePassword' className="form-control" value={formState.rePassword} onChange={handleChange}  placeholder="تکرار کلمه عبور" aria-label="تکرار کلمه عبور" aria-describedby="show-pass2"/>
                            <button className="btn btn-outline-light border border-secondary-subtle p-2" onClick={toggleRePassword} type="button" id="show-pass2"><i className="zmdi zmdi-eye text-secondary"></i></button>
                        </div>
                        <div className={`mb-3 ${subType === 0 ? "d-none" : ""}`}>
                            <input type="text" className="form-control" id="referral_code" name='referral_code' value={formState.referral_code} onChange={handleChange} placeholder="کد معرف (در صورت وجود)" />
                        </div>
                    </div>
                    <div className='d-none d-md-block col-md-6 text-center m-0 p-0'>
                        <img className='img-fluid' src={img1} alt='signup'/>
                    </div>
                </div> }
                
                {type === 2 && 
                <div className='row align-items-center g-0'>
                    <div className='col-md-6 col-sm-12 mt-4 mb-4'>
                        <div className="input-group mb-3">
                            <input type="text" className="form-control" id="site_name" name='site_name' value={formState.site_name} onChange={handleChange} placeholder="نام سایت شما (عنوان فارسی سایت)"/>
                        </div>
                        <div className='p-2 border rounded mb-3'>
                            <div className="input-group">
                                <div className="col-12 input-group-text rounded-0">
                                    <input role='button' className="form-check-input mt-0 me-2" name='is_new_domain' onChange={(e) => {setCheckme1(!e.target.checked); setCheckme2(e.target.checked); setFormState((prev) => ({ ...prev, 'is_new_domain': e.target.checked }))}} checked={formState.is_new_domain} type="radio" />
                                    <div role='button' onClick={() => {setCheckme1(false); setCheckme2(true); setFormState((prev) => ({ ...prev, 'is_new_domain': true }))}}>دامنه جدید ثبت می کنید؟</div>
                                </div>
                                <input type="url" name='domain' disabled={checkme1} className={`col-12 form-control rounded-0 m-0 ${checkme1 ? 'd-none' : ''}`} onChange={handleChange} placeholder="https://example.com" pattern="https://.*" size={30} value={formState.domain}/>
                            </div>
                            <div className="input-group">
                                <div className="col-12 input-group-text rounded-0">
                                    <input role='button' className="form-check-input mt-0 me-2" name='is_new_domain' onChange={(e) => {setCheckme2(!e.target.checked); setCheckme1(e.target.checked); setFormState((prev) => ({ ...prev, 'is_new_domain': !e.target.checked }))}} type="radio" checked={formState.is_new_domain === undefined ? false : !formState.is_new_domain}/>
                                    <div role='button' onClick={() => {setCheckme1(true); setCheckme2(false); setFormState((prev) => ({ ...prev, 'is_new_domain': false }))}}>یا، از قبل دامنه دارید؟</div>
                                </div>
                                <input type="url" name='domain' disabled={checkme2} className={`col-12 form-control rounded-0 m-0 ${checkme2 ? 'd-none' : ''}`} onChange={handleChange} placeholder="https://example.com" pattern="https://.*" size={30} value={formState.domain}/>
                            </div>
                            <div className='mt-4 border p-1 rounded'>
                                <p className='text-success mb-1'><i className="fas fa-gift me-1"></i>ساب دامنه شما (رایگان):</p>
                                {subDomain !== '' ? <p className='text-end p-0 m-0 text-secondary'>{subDomain}</p> : <p className='text-end p-0 m-0 text-secondary'>https://YOUR-DOMAIN.linket.me</p>}
                            </div>
                        </div>
                        <div className="input-group mb-3">
                            <label className="input-group-text" htmlFor="inputGroupSelect01">زمینه کاری:</label>
                            <select name='field_id' onChange={(e) => setFormState((prev) => ({ ...prev, 'field_id': +e.target.value }))} className="form-select" id="inputGroupSelect01">
                                {
                                    fieldsLoading ? 
                                        <option>انتخاب...</option>
                                    : 
                                        fields && Object.values(fields).map((value:any,index:number) => 
                                            <option value={value.id} key={index}>{value.name}</option> )
                                }
                            </select>
                        </div>

                        {/* <label className="form-check-label mb-1" htmlFor="select-theme">انتخاب قالب:</label> */}
                        <div className="form-check text-start ms-3" id='select-theme' style={{display:"none"}}>
                            <input className="form-check-input" name="is_vip" onChange={(e) => {setExtra(!e.target.checked); setFormState((prev) => ({ ...prev, 'is_vip': !e.target.checked }))}} type="radio" id="template-linket" checked={!formState.is_vip}/>
                            <label className="form-check-label" htmlFor="template-linket">
                                قالب های لینکت
                            </label>
                        </div>
                        {/* <div className="form-check text-start ms-3">
                            <input className="form-check-input" name="is_vip" onChange={(e) => {setExtra(e.target.checked); setFormState((prev) => ({ ...prev, 'is_vip': e.target.checked,'theme_id':undefined, 'theme_name':"" }))}} type="radio" id="template-vip" checked={formState.is_vip}/>
                            <label className="form-check-label" htmlFor="template-vip">
                                قالب اختصاصی (هزینه مازاد)
                            </label>
                        </div> */}
                    </div>
                    <div className='d-none d-md-block col-md-6 text-center'>
                        <img className='img-fluid' src={img2} alt='signup'/>
                    </div>
                </div> }
            
                {type === 3 && <div className='row align-items-center justify-content-center g-0'>
                    <div className='col-lg-8 col-sm-12 mt-4 mb-4'>
                        <div className={`mb-5 ${extra ? "d-none" : "d-block"}`}>
                            {
                            themesLoading ? 
                                <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                    <span className="visually-hidden">در حال لود قالب ها...</span>
                                    </div>
                                </div>                     
                            : 
                            <Flicking className='mb-4'
                                align="center"
                                // align= { {camera: "50%", panel: "50px"} }
                                panelsPerView= {2}
                                circular={true}
                                adaptive= {false}
                                plugins={_plugins}
                            >
                            {themes && Object.values(themes).map((value:any,index:number) => 
                                <div className='panel' key={index}>
                                    <div className="card text-start">
                                        <img src={value.image} className="card-img-top img-fluid" alt="theme"/>
                                        <div className="card-body">
                                            <h5 className="card-title">{value.name}</h5>
                                            <p className="card-text lh-sm">{value.bio}</p>
                                        </div>
                                        <ul className="list-group list-group-flush">
                                            <li className="list-group-item">
                                                <p className='float-start m-0 fw-semibold'>زمینه های کاری</p>
                                                <p className='float-end m-0'>{value.fields}</p>
                                            </li>
                                            <li className="list-group-item">
                                                <p className='float-start m-0 fw-semibold'>صفحات</p>
                                                <p className='float-end m-0'>{value.pages}</p>
                                            </li>
                                            <li className="list-group-item">
                                                <p className='float-start m-0 fw-semibold'>ماژول ها</p>
                                                <p className='float-end m-0'>{value.modules}</p>
                                            </li>
                                        </ul>
                                        <div className="card-footer text-body-secondary">
                                            <button type="button" onClick={() => setFormState((prev) => ({ ...prev, 'theme_id': +value.id,'theme_name': value.name }))} className="btn btn-outline-success m-0 btn-anim" data-bs-toggle="button">
                                                <i className="zmdi zmdi-star-circle zmdi-hc-spin me-1"></i>
                                                انتخاب این قالب
                                            </button>

                                            <a href={value.demo_link} target='_blank' rel="noreferrer" className="btn text-decoration-underline float-end text-primary">
                                            <i className="zmdi zmdi-eye me-1"></i>
                                             مشاهده دمو 
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <ViewportSlot>
                                <span className="flicking-arrow-prev"></span>
                                <span className="flicking-arrow-next"></span>
                            </ViewportSlot>
                            </Flicking>
                            }
                        </div>
                        
                        <br />
                        <div className="form-check mb-3">
                            <input className="form-check-input" checked={formState.is_vip} onChange={(e) => {setExtra(e.target.checked); setFormState((prev) => ({ ...prev, 'is_vip': e.target.checked,'theme_id':undefined, 'theme_name':"" }))}} type="checkbox" id="vip-check"/>
                            <label className="form-check-label" htmlFor="vip-check">
                                قالب های بالا پاسخگوی کار شما نیست و نیاز به طراحی قالب اختصاصی دارید؟ (همراه با هزینه)
                            </label>
                        </div>
                        <div className={`mb-3 border border-info rounded p-3  ${extra ? "d-block" : "d-none"}`}>
                            <p className='fs-6'>با پاسخ به چند پرسش زیر به ما کمک کنید تا سایت دلخواه شما را برایتان ایجاد کنیم:</p>
                            <label className="form-check-label mb-2 fw-semibold" htmlFor="graphic-check">
                                ۱- آیا طرح گرافیکی قالب برای شما طراحی گردد؟ 
                            </label>
                            <div className="mb-3" id="graphic-check">
                                <div className="form-check ms-3">
                                    <input className="form-check-input" onChange={(e) => setFormState((prev) => ({ ...prev, 'graphic': e.target.checked }))} type="radio" name="graphic" id="flexRadioDefault1" checked={formState.graphic}/>
                                    <label className="form-check-label" htmlFor="flexRadioDefault1">
                                        بله، قالب گرافیکی طراحی شود. (PSD)
                                    </label>
                                </div>
                                <div className="form-check ms-3">
                                    <input className="form-check-input" onChange={(e) => setFormState((prev) => ({ ...prev, 'graphic': !e.target.checked }))} type="radio" name="graphic" id="flexRadioDefault2" checked={!formState.graphic}/>
                                    <label className="form-check-label" htmlFor="flexRadioDefault2">
                                        خیر، قالب یا نمونه جهت طراحی دارم.
                                    </label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className="col-md-8 col-sm-12 mb-3">
                                    <label htmlFor="type-input" className="form-label fw-semibold">۲- نوع قالب سایت:</label>
                                    <input type="text" name='1' onChange={handleAnswerChange} value={Object.values(formState.answers)[0]} className="form-control" id="type-input" placeholder='مینیمال، ‌تجملاتی، مدرن یا ...'/>
                                </div>
                                <div className="col-md-4 col-sm-12 mb-3" >
                                    <label htmlFor="color-input" className="form-label fw-semibold">۳- رنگ پیشنهادی:</label>
                                    <input type="text" name='2' onChange={handleAnswerChange} value={Object.values(formState.answers)[1]} className="form-control" id="color-input"/>
                                </div>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="note-input" className="form-label fw-semibold">۴- چه قالبی مد نظر شماست؟</label>
                                <textarea className="form-control" name='3' onChange={handleAnswerChange} value={Object.values(formState.answers)[2]} id="note-input" placeholder='اندکی درباره سایت مد نظر خود برای ما بنویسید' rows={2}></textarea>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="pages-num" className="form-label fw-semibold">۵- تعداد صفحات سایت:</label>
                                <input type="range" onChange={(e) => setFormState((prev) => ({ ...prev, 'pages': +e.target.value }))} value={formState.pages} name="pages" className="form-range" min="1" max="12" id="pages-num"/>
                            </div>
                            
                            <div className="mb-3 mt-2">
                                <h6> حدود هزینه قالب اختصاصی شما شامل 
                                    <span className="mx-2 text-decoration-underline fw-bold fs-5">
                                        {fa_number(formState.pages)}
                                    </span> 
                                    صفحه
                                    <span className="ms-1 text-decoration-underline">
                                        {formState.graphic ? "همراه با طراحی گرافیک اختصاصی" : ""}
                                    </span> 
                                    ،
                                    <span className="badge bg-success mx-1 fs-6">
                                        {calc_price(formState.pages,formState.graphic)}
                                    </span>
                                        تومان برآورد شده است.
                                </h6>
                                <p className='text-secondary'>*هزینه به صورت حدودی می باشد و در روال ثبت نام نیازی به پرداخت نیست.</p>
                            </div>
                        </div>
                        
                        <div className="form-check mt-3 mb-3">
                            <input className="form-check-input" onChange={(e) => setFormState((prev) => ({ ...prev, 'is_consult': e.target.checked }))} type="checkbox" id="consult-check" checked={formState.is_consult}/>
                            <label className="form-check-label" htmlFor="consult-check">
                                نیاز به مشاوره برای انتخاب قالب دارم (رایگان)
                            </label>
                        </div>

                    </div>
                </div> }

                {type === 4 && <div className='row text-center align-items-center justify-content-center g-0'>
                    <div className='col-lg-8 col-sm-12 border rounded px-0 py-4 mt-4 mb-5'>
                        <h4 className='text-success fs-3 mb-4'>تبریک میگیم :)</h4>
                        <p>سایت شما با اطلاعات زیر ایجاد شد:</p>
                        <table className="table table-hover">
                            <tbody>
                                <tr>
                                    <th scope="row">نام سایت:</th>
                                    <td>{formState.site_name}</td>
                                </tr>
                                <tr>
                                    <th scope="row">وضعیت دامنه:</th>
                                    <td>{formState.is_new_domain ? "خرید دامنه جدید" : "دامنه دارید"}</td>
                                </tr>
                                <tr>
                                    <th scope="row">نام دامنه:</th>
                                    <td>{formState.domain}</td>
                                </tr>
                                <tr>
                                    <th scope="row">قالب انتخابی:</th>
                                    <td className={`${(!formState.is_vip && !formState.theme_id) ? "table-danger" : ""}`}>{formState.is_vip ? "طراحی قالب اختصاصی" : formState.theme_id ? formState.theme_name : "قالبی انتخاب نکرده اید!"}</td>
                                </tr>
                                { formState.is_vip &&
                                <>
                                    <tr>
                                        <th scope="row">طراحی گرافیکی:</th>
                                        <td>{formState.graphic ? "قالب گرافیکی به صورت PSD  برای شما طراحی می گردد." : "طرح قالب شما از قبل طراحی شده و در اختیار ما میگذارید."}</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">تعداد صفحات مورد نیاز:</th>
                                        <td>{fa_number(formState.pages)} صفحه</td>
                                    </tr>
                                    <tr>
                                        <th scope="row" colSpan={2}>سوالات پیشنیاز طراحی:</th>
                                    </tr>
                                    <tr>
                                        <td colSpan={2}>{Object.values(formState.answers).map((val,index) => <p>سوال {fa_number(index + 1)}: {val ? val : "پاسخ داده نشده!"}</p>)}</td>
                                    </tr>
                                </>
                                }
                            </tbody>
                        </table>
                        
                        <p className='mt-4'>
                            <i className="zmdi zmdi-badge-check text-success me-1"></i>
                            در صورتی که موارد فوق مورد تایید شماست وارد پنل مدیریت شوید یا در غیر این صورت قبل از تایید نهایی موارد را تغییر دهید.
                        </p>
                        <div className="mt-4">
                            {lastStep ? 
                            <button type="button" className="btn btn-primary">
                                <span className="spinner-grow spinner-grow-sm me-1" role="status" aria-hidden="true"></span>
                                سایت شما در حال ایجاد می باشد... (تا ۲۵ ثانیه دیگر به پنل مدیریت سایت هدایت خواهید شد)
                            </button>
                            :
                            <>
                            <button type="button" disabled={isLastLoading} className='btn btn-outline-secondary mb-2' onClick={() => setType((prev) => prev > 1 ? prev - 1 : 1)}>بازگشت به مراحل ثبت نام</button>
                            <button type="submit" disabled={isLastLoading} className='btn btn-success ms-2 mb-2'>
                                <i className="zmdi zmdi-check me-1"></i>
                                تایید و ورود به پنل مدیریت سایت
                            </button>
                            </>
                            }
                        </div>
                        
                    </div>
                </div>}
            
                
                {type !== 4 && <div className="form-footer d-flex mt-4">
                    { (type === 1) ?
                        (subType === 0) ?
                            <Link to="/login" type="button" className='btn btn-outline-primary'>قبلا ثبت نام کرده اید؟</Link>
                        :
                            <button type="button" className='btn btn-secondary' onClick={() => window.location.reload()}>تغییر شماره</button>
                        : 
                        <button type="button" className='btn btn-secondary' onClick={() => setType((prev) => prev > 1 ? prev - 1 : 1)}>مرحله قبل</button>
                    }
                    <button type="submit" disabled={isLoading || isCodeLoading || isSiteLoading || isSurveyLoading} className='btn btn-success'>{type === 3 ? "ثبت نهایی" : "مرحله بعد"}</button>
                </div>}

            </form>
        </div>
    )
}